const LOGO_URL = 'https://files.catbox.moe/lhd8h5.svg';

export default function Header() {
  return (
    <header
      style={{
        height: '50px',
        background: '#fff',
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '6px 16px',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      <a
        href="https://nijikango.co.jp/"
        aria-label="ニジ看護転職 公式サイトへ"
        style={{ display: 'inline-flex', alignItems: 'center' }}
      >
        <img
          src={LOGO_URL}
          alt="ニジ看護転職"
          style={{
            height: '36px',
            width: 'auto',
            objectFit: 'contain',
            objectPosition: 'left center',
          }}
        />
      </a>
      <div
        style={{
          fontSize: '10px',
          color: '#aaa',
          textAlign: 'right',
          lineHeight: 1.4,
          flexShrink: 0,
        }}
      >
        厚生労働大臣許可証
        <br />
        13-ユ-317878
      </div>
    </header>
  );
}
